import { ButtonRadioGroup } from '@/components/common/Button'
import { useIsNavigating } from '@/components/providers/NavigationProvider'
import { usePage } from '@/components/providers/PageProvider'
import { FILTER_TIMEFRAME_EMPTY_LABEL, FILTER_TIMEFRAME_LABELS } from '@/defs/filters'
import { SCROLL_GALLERY } from '@/defs/scroll'
import { useLinkInternal } from '@/hooks/useLinkInternal'

export const FilterInputTimeframe = () => {
  const { buildRelative } = useLinkInternal()
  const isNavigating = useIsNavigating()
  const { page } = usePage()

  const route = page?.route
  const timeframeOptions = page?.optionsFilters?.timeframes

  if (!timeframeOptions) return null

  const options = [
    {
      isSelected: !route?.timeframe,
      label: FILTER_TIMEFRAME_EMPTY_LABEL.label,
      linkInternalProps: {
        href: buildRelative({ timeframe: undefined }),
        scroll: SCROLL_GALLERY,
      },
      title: FILTER_TIMEFRAME_EMPTY_LABEL.labelLong,
    },
    ...timeframeOptions.map((timeframe) => {
      const isSelected = timeframe === route?.timeframe

      return {
        isSelected,
        label: FILTER_TIMEFRAME_LABELS[timeframe].label,
        linkInternalProps: {
          href: buildRelative({ timeframe: !isSelected ? timeframe : undefined }),
          scroll: SCROLL_GALLERY,
        },
        title: FILTER_TIMEFRAME_LABELS[timeframe].labelLong,
      }
    }),
  ]

  return <ButtonRadioGroup allowSelectedLink options={options} showLoadingMask={isNavigating} />
}
